import React from 'react';

/** @typedef {import('../../../types').BlacklistEntry} BlacklistEntry */

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import { getLocationStringDefault, cleanLocationString } from '../../../../../../../address/address-fields/helpers';

/**
 * @param {object} props
 * @param {{ original: BlacklistEntry }} props.row
 * @returns {JSX.Element}
 */
export const AddressCell = ({ row }) => {
  const { addressLine1, addressLine2, city, state, postalCode, countryCode } = row.original;
  const locationString = getLocationStringDefault(city, state, postalCode);

  return (
    <div>
      {cleanLocationString(addressLine1) ? <Text shouldTruncate textType={TextType.Paragraph} value={addressLine1} /> : null}
      {cleanLocationString(addressLine2) ? <Text shouldTruncate textType={TextType.Paragraph} value={addressLine2} /> : null}
      {locationString ? <Text shouldTruncate textType={TextType.Paragraph} value={locationString} /> : null}
      <Text textType={TextType.Paragraph} value={countryCode} />
    </div>
  );
};

export const createAddressColumnDefinition = (columnOverrides) =>
  createColumnDefinitionBuilder({
    accessor: 'addressLine1',
    Header: <Text textType={TextType.Label} value={messages.addressColumnHeader} />,
    Cell: AddressCell,
    width: 3,
  })(columnOverrides);
